import React, { useState } from 'react'
import {
  Grid,
  Button
} from '@mui/material'
import UserDetail from '../user-detail'
import { useUserList } from '../hooks'
import { useSelector } from 'react-redux'
import { TenantEditSlice } from '../../../../reducers'
import { useStyles } from '../style'
import useUserSearch from '../hooks/useUserSearch'
import UsersTable from './table'

const UserList = ({ filters }) => {
  const classes = useStyles()

  const tenant = useSelector(TenantEditSlice.selectors.tenant)
  const { userPoolId, pk: tenantId } = tenant

  const [selectedUsers, setSelectedUsers] = useState([])
  const [userDetail, setUserDetail] = useState()

  const { searchTerm } = useUserSearch({ term: filters.search, field: filters.field })

  const { userList, isLoading: isLoadingUsers, isFetchingMore, onFetchMoreUsers, onListUsers, lastKey } = useUserList({
    userPoolId,
    filter: searchTerm
  })

  const isLoading = isLoadingUsers || isFetchingMore

  const handleUserClick = user => {
    setUserDetail(user)
  }

  const backToListClick = () => {
    setUserDetail(undefined)
  }

  if (userDetail) {
    return (
      <UserDetail
        userPoolId={userPoolId}
        user={userDetail}
        onBackToListClick={() => backToListClick()}
        tenantId={tenantId}
      />
    )
  }

  return (
    <>
      <UsersTable
        userList={userList}
        onListUsers={onListUsers}
        isLoading={isLoading}
        selectedUsers={selectedUsers}
        setSelectedUsers={setSelectedUsers}
        handleUserClick={handleUserClick}
      />
      {!isLoading && lastKey && (
        <Grid
          id='users-list-load-more'
          container
          direction='row'
          justifyContent='center'
          align='center'
          classes={{ root: classes.loadMoreBtn }}
          style={{ display: userDetail ? 'none' : 'inherit' }}
        >
          <Grid item xs={12}>
            <Button
              variant='contained'
              color='primary'
              data-test='load-more-button'
              onClick={onFetchMoreUsers}
            >
              Load More
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default UserList
